"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var mobx_react_1 = require("mobx-react");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var socialAuthApi_1 = __importDefault(require("../../../api/socialAuthApi"));
var path_1 = require("../../../definition/path");
var storeProvider_1 = require("../../../storeProvider");
var FacebookAuthButton_1 = __importDefault(require("./FacebookAuthButton"));
var GoogleAuthButton_1 = __importDefault(require("./GoogleAuthButton"));
var LineAuthButton_1 = __importDefault(require("./LineAuthButton"));
var SocialLoginPanel_module_scss_1 = __importDefault(require("./SocialLoginPanel.module.scss"));
var loginActions = [];
var POLL_DELAY_MS = 900;
var POLL_MAX_ATTEMPTS = 8;
var delay = function (ms) {
    return new Promise(function (resolve) {
        window.setTimeout(function () { return resolve(); }, ms);
    });
};
var SocialLoginPanel = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, storeProvider_1.useStore)(), authStore = _a.authStore, offerStore = _a.offerStore;
    var _b = (0, react_1.useState)(""), toastMessage = _b[0], setToastMessage = _b[1];
    var _c = (0, react_1.useState)(false), isLoading = _c[0], setIsLoading = _c[1];
    var toastTimeoutRef = (0, react_1.useRef)(null);
    var socialSessionRef = (0, react_1.useRef)({
        googleUser: null,
        accessToken: ""
    });
    var actionDisabled = (0, react_1.useMemo)(function () { return isLoading; }, [isLoading]);
    (0, react_1.useEffect)(function () {
        if (authStore.userProfile) {
            return;
        }
        var storedLineUser = window.sessionStorage.getItem("pos.socialAuth.lineUser");
        if (!storedLineUser) {
            return;
        }
        try {
            var user = JSON.parse(storedLineUser);
            var userId = user.id || user.sub || "";
            if (!userId || !user.email) {
                window.sessionStorage.removeItem("pos.socialAuth.lineUser");
                return;
            }
            void authStore.fetchUserProfile({
                userId: userId,
                email: user.email,
                name: user.name
            });
        }
        catch (_a) {
            // ignore malformed stored LINE user data
        }
    }, []);
    var showToast = function (message) {
        setToastMessage(message);
        if (toastTimeoutRef.current) {
            window.clearTimeout(toastTimeoutRef.current);
        }
        toastTimeoutRef.current = window.setTimeout(function () {
            setToastMessage("");
            toastTimeoutRef.current = null;
        }, 2500);
    };
    var pollTask = function (requestId) { return __awaiter(void 0, void 0, void 0, function () {
        var attempt, task;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    attempt = 0;
                    _a.label = 1;
                case 1:
                    if (!(attempt < POLL_MAX_ATTEMPTS)) return [3 /*break*/, 5];
                    return [4 /*yield*/, socialAuthApi_1.default.getTaskStatus(requestId)];
                case 2:
                    task = _a.sent();
                    if (task.status === "success") {
                        return [2 /*return*/, task];
                    }
                    if (task.status === "failed") {
                        throw new Error(task.error_message || t("SOCIAL_LOGIN_ERROR_FAILED"));
                    }
                    return [4 /*yield*/, delay(POLL_DELAY_MS)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    attempt += 1;
                    return [3 /*break*/, 1];
                case 5: throw new Error(t("SOCIAL_LOGIN_ERROR_PROCESSING"));
            }
        });
    }); };
    var startSocialLogin = function (provider, label) { return __awaiter(void 0, void 0, void 0, function () {
        var token, queuedTask, completedTask, error_1, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = window.prompt(t("SOCIAL_LOGIN_PROMPT_TOKEN", { label: label }));
                    if (!token) {
                        return [2 /*return*/];
                    }
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, socialAuthApi_1.default.startSocialLogin({
                            provider: provider,
                            access_token: token
                        })];
                case 2:
                    queuedTask = _a.sent();
                    return [4 /*yield*/, pollTask(queuedTask.request_id)];
                case 3:
                    completedTask = _a.sent();
                    if (completedTask.access_token) {
                        window.sessionStorage.setItem("pos.socialAuth.accessToken", completedTask.access_token);
                    }
                    showToast(t("SOCIAL_LOGIN_TOAST_SUCCESS", { label: label }));
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    message = error_1 instanceof Error
                        ? error_1.message
                        : t("SOCIAL_LOGIN_ERROR_FAILED");
                    showToast(t("SOCIAL_LOGIN_TOAST_FAILED", { label: label, message: message }));
                    return [3 /*break*/, 6];
                case 5:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleGoogleAuthenticated = function (result) {
        socialSessionRef.current.googleUser = result.user;
        socialSessionRef.current.accessToken =
            result.access_token || result.session_id || "";
        window.sessionStorage.setItem("pos.socialAuth.googleUser", JSON.stringify(result.user));
        if (result.access_token || result.session_id) {
            window.sessionStorage.setItem("pos.socialAuth.accessToken", result.access_token || result.session_id);
        }
        void authStore.fetchUserProfile({
            userId: result.user.sub,
            email: result.user.email,
            name: result.user.name,
            avatarUrl: result.user.picture
        });
        showToast(t("SOCIAL_LOGIN_TOAST_GOOGLE_SUCCESS"));
    };
    var handleGoogleError = function (message) {
        socialSessionRef.current.googleUser = null;
        socialSessionRef.current.accessToken = "";
        showToast(t("SOCIAL_LOGIN_TOAST_GOOGLE_FAILED", { message: message }));
    };
    var handleFacebookAuthenticated = function (result) {
        window.sessionStorage.setItem("pos.socialAuth.facebookUser", JSON.stringify(result.user));
        window.sessionStorage.setItem("pos.socialAuth.accessToken", result.access_token || result.session_id);
        void authStore.fetchUserProfile({
            userId: result.user.id,
            email: result.user.email,
            name: result.user.name
        });
        showToast(t("SOCIAL_LOGIN_TOAST_FACEBOOK_SUCCESS"));
    };
    var handleFacebookError = function (message) {
        showToast(t("SOCIAL_LOGIN_TOAST_FACEBOOK_FAILED", { message: message }));
    };
    var handleLineError = function (message) {
        showToast(t("SOCIAL_LOGIN_TOAST_LINE_FAILED", { message: message }));
    };
    var handleLogout = function () {
        authStore.logout();
    };
    var goToTickets = function () {
        navigate("".concat(path_1.Page.TicketPage, "?session-id=").concat(encodeURIComponent(offerStore.sessionId)));
    };
    if (authStore.userProfile) {
        var profile = authStore.userProfile;
        return ((0, jsx_runtime_1.jsxs)("section", { className: SocialLoginPanel_module_scss_1.default.loginPanel, "aria-label": t("SOCIAL_LOGIN_ARIA_PROFILE"), children: [(0, jsx_runtime_1.jsxs)("div", { className: SocialLoginPanel_module_scss_1.default.profileCard, children: [profile.avatar_url ? ((0, jsx_runtime_1.jsx)("img", { className: SocialLoginPanel_module_scss_1.default.profileAvatar, src: profile.avatar_url, alt: "", "aria-hidden": "true" })) : ((0, jsx_runtime_1.jsx)("span", { className: SocialLoginPanel_module_scss_1.default.profileAvatarFallback, children: (profile.name || profile.email)
                                .charAt(0)
                                .toUpperCase() })), (0, jsx_runtime_1.jsxs)("div", { className: SocialLoginPanel_module_scss_1.default.profileMeta, children: [(0, jsx_runtime_1.jsx)("p", { className: SocialLoginPanel_module_scss_1.default.profileName, children: profile.name }), (0, jsx_runtime_1.jsx)("p", { className: SocialLoginPanel_module_scss_1.default.profileEmail, children: profile.email })] }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: SocialLoginPanel_module_scss_1.default.profileLogoutButton, onClick: handleLogout, children: t("SOCIAL_LOGIN_LOGOUT") })] }), (0, jsx_runtime_1.jsx)("div", { className: SocialLoginPanel_module_scss_1.default.profileActionGrid, children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "".concat(SocialLoginPanel_module_scss_1.default.profileActionButton, " ").concat(SocialLoginPanel_module_scss_1.default.profileActionPrimary), onClick: goToTickets, children: t("SOCIAL_LOGIN_ACTION_START_EXAM") }) })] }));
    }
    return ((0, jsx_runtime_1.jsxs)("section", { className: SocialLoginPanel_module_scss_1.default.loginPanel, "aria-label": t("SOCIAL_LOGIN_ARIA_METHODS"), children: [toastMessage ? ((0, jsx_runtime_1.jsx)("div", { className: SocialLoginPanel_module_scss_1.default.inlineToast, role: "status", "aria-live": "polite", children: toastMessage })) : null, (0, jsx_runtime_1.jsxs)("div", { className: SocialLoginPanel_module_scss_1.default.buttonGrid, children: [(0, jsx_runtime_1.jsx)(GoogleAuthButton_1.default, { onAuthenticated: handleGoogleAuthenticated, onError: handleGoogleError, onLoadingChange: setIsLoading }), (0, jsx_runtime_1.jsx)(FacebookAuthButton_1.default, { onAuthenticated: handleFacebookAuthenticated, onError: handleFacebookError, onLoadingChange: setIsLoading }), (0, jsx_runtime_1.jsx)(LineAuthButton_1.default, { onError: handleLineError, disabled: actionDisabled }), loginActions.map(function (action) { return ((0, jsx_runtime_1.jsx)("button", { className: SocialLoginPanel_module_scss_1.default.loginButton, type: "button", disabled: actionDisabled, onClick: function () {
                            return startSocialLogin(action.provider, t(action.labelKey));
                        }, children: t(action.labelKey) }, action.provider)); })] })] }));
};
exports.default = (0, mobx_react_1.observer)(SocialLoginPanel);
